import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import Typography from "@mui/material/Typography";

import Box from "ui/atom/Box";
import Link from "ui/atom/Link";
import Image from "ui/base/Image";

import "swiper/css";
import "swiper/css/autoplay";


export default function Partners({ partners }) {
	const loop = partners?.length > 3; // Loop if more than 3 partners
	const style = {
		root: {
			justifyContent: "center",
			alignItems: "center",
			"& .swiper-wrapper": {
				transitionTimingFunction: "linear"
			},
			"& .swiper-slide": {
				width: { xs: "70%", sm: "50%", md: "33%" }
			}
		},
		title: {
			textAlign: "center"
		},
		swiper: {
			width: "100%"
		},
		link: {
			display: "flex",
			mx: "auto",
			width: "min-content"
		},
		logo: {
			height: { xs: "30px", ms: "44px" },
			width: "auto"
		}
	};

	return partners?.length > 0 && (
		<Box.Column gap={4} sx={style.root}>
			<Typography variant="body1" component="span" fontSize={20} sx={style.title}>
				<Typography variant="h4" component="span">Trusted</Typography> by news organizations worldwide
			</Typography>
			<Swiper
				modules={[Autoplay, FreeMode]}
				autoplay={loop && {
					delay: 0,
					disableOnInteraction: false
				}}
				speed={10000}
				spaceBetween={15}
				centeredSlides={loop}
				slidesPerView={loop ? "auto" : partners.length}
				loop={loop}
				style={style.swiper}
			>
				{partners.map((p, k) => (
					<SwiperSlide key={k}>
						<Link to={p.url} tab sx={style.link}>
							<Image src={p.logo.light} title={p.name} sx={style.logo} />
						</Link>
					</SwiperSlide>
				))}
			</Swiper>
		</Box.Column >
	);
};